var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#FF5353",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2302_15521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 47,
    height: 47
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6 17H17V63.6H63.6V17Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2302_15521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1352 57.074C20.2512 53.3231 17.7905 48.3397 17.1736 42.9756C16.5567 37.6114 17.822 32.1995 20.7532 27.6649C23.6844 23.1303 28.0996 19.7545 33.244 18.1145C38.3884 16.4744 43.9427 16.672 48.9576 18.6734C53.9725 20.6748 58.1366 24.3558 60.7381 29.0873C63.3397 33.8187 64.2173 39.3068 63.2209 44.6136C62.2244 49.9203 59.4158 54.7163 55.2751 58.1817C51.1344 61.6471 45.9186 63.5669 40.5193 63.6128C34.412 63.6648 28.5285 61.3167 24.1352 57.074ZM43.8686 40.6026L50.4617 34.0095L47.1767 30.7244L40.6066 37.3176L34.0134 30.7244L30.7284 34.0095L37.3215 40.6026L30.7284 47.1958L34.0134 50.4809L40.6066 43.8877L47.1997 50.4809L50.4848 47.1958L43.8916 40.6026H43.8686Z",
    fill: "#FF5353",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.d99e77eb27a547dfcdbce32759709b6c.svg";
export { ForwardRef as ReactComponent };